import { ERROR } from "avcore";

// avcore-server rejects these for the token itself (its stream or operation
// claim does not match the request), so a retry with the same credentials
// fails the same way. A new request with fresh credentials (room stream list)
// is still subscribed.
const PERMANENT_SUBSCRIBE_ERROR_IDS: readonly unknown[] = [
  ERROR.UNAUTHORIZED,
  ERROR.INVALID_OPERATION
];

export function isPermanentSubscribeError(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    PERMANENT_SUBSCRIBE_ERROR_IDS.includes(
      (error as { errorId?: unknown }).errorId
    )
  );
}
